import { Transfer } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setTargetKeys } from '../../../redux/peakList/action';
import CustomModal from "../../../hoc/CustomModal";
import PopComponent from "../../popContent";
import { addRecommendedGroup, addRecommendedGroupPublic } from '../../../api/groups';
import icon_lock_group from '../../../assets/images/icon_lock_group.svg';

const PeakList = ({ filteredGroups, publicRec, handleOpenModal }) => {
    const [modalName, setModalName] = useState("UserPop");
    const [openModal, setModalOpen] = useState(false);
    const [error, setError] = useState({});
    let Modal = PopComponent[modalName];
    const [recNum, setRecNum] = useState(1);
    const courseData = [];

    filteredGroups.filter(_ => publicRec ? _.Owner === 'Community Manager' && _.type === 'open' : _.Owner === 'Community Manager' && _.course === 'No').map(data => (
        courseData.push({
            key: data._id,
            type: data.type,
            title: data.name || data.title,
            description: data.name || data.title,
        })
    ));

    useEffect(() => {
        setRecNum(publicRec ? 2 : 1)
    }, [publicRec])

    const targetKeys = useSelector(state => state.peakListReducer)
    const dispatch = useDispatch();

    const [selectedKeys, setSelectedKeys] = useState([]);

    const onChange = (nextTargetKeys, direction, moveKeys) => {
        if (direction === 'right' && targetKeys.length < recNum) {
            dispatch(setTargetKeys(nextTargetKeys))
        } else if (direction === 'left') {
            dispatch(setTargetKeys(nextTargetKeys))
        }
    };

    const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        if (sourceSelectedKeys.length > recNum) {
            sourceSelectedKeys.shift();
        }
        if (sourceSelectedKeys.length <= recNum && targetKeys.length < recNum && sourceSelectedKeys.length + targetKeys.length <= recNum) {
            setSelectedKeys([...targetSelectedKeys, ...sourceSelectedKeys]);
        }
    };

    const filterOption = (inputValue, option) => option.title.indexOf(inputValue) > -1;

    const handleSubmit = () => {
        if (targetKeys.length <= recNum) {
            const rec = publicRec ? addRecommendedGroupPublic : addRecommendedGroup
            const req = {}
            req.group_ids = [...targetKeys]
            rec(req).then(res => {
                if (res.data.status === 200) {
                    handlePopModal('ErrorPop', { header: "Success", body: res.data.message })
                } else {
                    handlePopModal('ErrorPop', { header: "Error", body: res.data.message })
                }
            }).catch(err => {
                handlePopModal('ErrorPop', { header: "Error", body: err.message })
            })
        } else {
            handlePopModal('ErrorPop', { header: "Error", body: "recommended course can't be more then 4" })
        }
    };

    const handlePopModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    return (
        <div className="peak_list">
            <h2>{`${publicRec ? 'open' : 'featured'}`} groups</h2>
            <Transfer
                dataSource={courseData}
                titles={['Source', 'Target']}
                targetKeys={targetKeys}
                selectedKeys={selectedKeys}
                filterOption={filterOption}
                onChange={onChange}
                onSelectChange={onSelectChange}
                render={item => item.type === 'closed' && !targetKeys.find(tar => tar === item.key) ? <div className='d_flex justify_content_between'><p>{item.title}</p><span><img src={icon_lock_group} alt='lock' /></span></div> : item.title}
                showSelectAll={false}
                showSearch={true}
                oneWay={true}
            />
            <div class="form_group form_footer">
                <button onClick={() => handleOpenModal()} type="reset" class="btn btn_gray">Cancel</button>
                <button onClick={() => handleSubmit()} type="submit" class="btn btn_primary">submit</button>
            </div>
            {Modal && (
                <CustomModal className={`${modalName === 'ErrorPop' ? 'ant-modal modal skill_model' : 'modal peak_model'} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                    <Modal
                        error={error}
                        handleOpenModal={handleOpenModal}
                    />
                </CustomModal>
            )
            }
        </div>
    )
};

export default PeakList